import { CloseOutlineIcon } from './CloseOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 2FEE0020-4271-487C-897D-75529B20C4C6
 * name close-outline
 * version: 1.8.36
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/close-outline.svg
 * tags
 */
export const MultiplyOutlineIcon = CloseOutlineIcon;
export default MultiplyOutlineIcon